import {trackPromise} from "react-promise-tracker";
import Api from "../../services/api-config";

export interface FeatureFlagContextData {
    poMonitoringEnabled: boolean;
    registrationsEnabled: boolean;
    categoriesEnabled: boolean;
    projectsEnabled: boolean;
    reportsEnabled: boolean;
    reportsAssetControlEnabled: boolean;
    reportsRelatedCostsEnabled: boolean;
    importsEnabled: boolean;
    importsAmortizationEnabled: boolean;
    importsPurchaseOrderEnabled: boolean;
    importsRelatedCostsEnabled: boolean;
    authenticationByHUB: boolean;
}

export const fetchFeatures = async (): Promise<{
    features: FeatureFlagContextData;
}> => {
    try {
        const res = await trackPromise(Api.get<FeatureFlagContextData>('/api/general/feature-flags'));
        const features = res.data;
        return { features };
    } catch (error) {
        console.error('Erro ao carregar features:', error);
        return { features: {} as FeatureFlagContextData };
    }
};
